import { Card, Image, Button, Icon } from 'semantic-ui-react';

import React from 'react';

class ActionCard extends React.Component {
  constructor(props) {
    super();

    this.toggleCollapse = this.toggleCollapse.bind(this);
    this.renderExpandedCard = this.renderExpandedCard.bind(this);
    this.renderCollapseCard = this.renderCollapseCard.bind(this);
    this.renderHowToButton = this.renderHowToButton.bind(this);
    this.getChanVariables = this.getChanVariables.bind(this);

    this.state = {
      isCollapsed: false,
    }
  }

  //TODO: Refactor these sins of my youth below here! passing parent's loading state
  getChanVariables(lookUpVal) {
    // this is required to not call object properties which aren't loaded yet.
    // I wish I could call my younger self.
    const chanURL = (this.props && this.props.channel)
    ? this.props.channel.url
    : 'loading...';

    const color = (this.props && this.props.channel)
    ? this.props.channel.color
    : 'loading...';

    const logo = (this.props && this.props.channel)
    ? this.props.channel.logo
    : 'loading...';

    switch (lookUpVal) {
      case 'chanURL':
        return chanURL;
      case 'color':
        return color;
      case 'logo':
        return logo;
      default:
        return null;
    }
  }

  toggleCollapse() {
    this.setState({
      isCollapsed: !this.state.isCollapsed
    });
  }

  renderHowToButton(props) {
    return (
      <Button compact primary animated
        floated='right'
        onMouseDown={() => this.context.router.history.push(
          `${this.getChanVariables('chanURL')}/${props.action.url}`
        )} >
        <Button.Content visible>How To</Button.Content>
        <Button.Content hidden>
        <Icon name='right arrow' />
        </Button.Content>
      </Button>
    )
  }

  renderCollapseCard(props) {
    return(
      <Card className='resultCard'>
        <button
          className="ui labeled icon basic top attached button"
          onClick={() => this.toggleCollapse()}
        >
          <i
            className={`${this.getChanVariables('logo')} icon`}
            style={{backgroundColor: this.getChanVariables('color'), color:'#FFF'}}
          />
          {(this.props.action)
            ? this.props.action.name
            : 'loading...'}
        </button>
      </Card>
    )
  }

  renderExpandedCard(props) {
    return(
      <Card className='resultCard' onBlur={() => this.toggleCollapse()}>
        <button
          className="ui labeled icon basic top attached button"
          onClick={() => this.toggleCollapse()}>
          <i
            className={`${this.getChanVariables('logo')} icon`}
            style={{backgroundColor: this.getChanVariables('color'), color: '#fff'}}
          />
          {(this.props.action)
            ? this.props.action.name
            : 'loading...'}
        </button>
        <Image src={`${props.action.imgUrl}`} />
        <Card.Content>
          <Card.Meta>
            {props.action.descr}
          </Card.Meta>
        </Card.Content>
        <Card.Content>
          <Button compact
            floated='left'
            content='Cancel'
            onClick={() =>
            this.toggleCollapse()}
          />
          {(this.props.howToButton)
            ? this.renderHowToButton(this.props)
            : ''}
        </Card.Content>
      </Card>
    )
  }

  render() {
    return (this.state.isCollapsed)
    ? this.renderExpandedCard(this.props)
    : this.renderCollapseCard(this.props)
  }
}

ActionCard.contextTypes = {
  router: React.PropTypes.object
}

export default ActionCard;



// WEBPACK FOOTER //
// ./src/components/ActionCard.js